import React from "react";
import {
    ControlLabel,
    Row,
    Col,
} from "react-bootstrap";
import { useModuleSettingsContext } from "../../../../context";
import RichEditor from "../../../RichEditor";
import PanelTabWrapper from "../PanelTabWrapper";

const Information = () => {
    const {
        moduleInformation,
        onSaveInformation,
        setPropertyInformation,
        isSaving,
    } = useModuleSettingsContext();

    return (
        <PanelTabWrapper title="Информация">
            <Row>
                <Col xs={6}>
                    <ControlLabel>Текст [Ru]</ControlLabel>
                    <RichEditor
                        value={moduleInformation.text_ru}
                        onChange={(e) => setPropertyInformation('text_ru', e.editor.getData())}
                        onBlur={onSaveInformation}
                        disabled={isSaving}
                    />
                </Col>
                <Col xs={6}>
                    <ControlLabel>Текст [En]</ControlLabel>
                    <RichEditor
                        value={moduleInformation.text_en}
                        onChange={(e) => setPropertyInformation('text_en', e.editor.getData())}
                        onBlur={onSaveInformation}
                        disabled={isSaving}
                    />
                </Col>
            </Row>
        </PanelTabWrapper>
    );
};

export default Information;